import { cssVar, defineStyleConfig } from '@chakra-ui/react';

const $color = cssVar('spinner-color');
const $emptyColor = cssVar('spinner-empty-color');

export const spinnerTheme = defineStyleConfig({
  baseStyle: {
    color: $color.reference,
    borderBottomColor: $emptyColor.reference,
    borderLeftColor: $emptyColor.reference,
    _dark: {
      [$color.variable]: 'colors.spinner.main',
      [$emptyColor.variable]: 'colors.spinner.bg',
    },
  },
  defaultProps: {
    // Note: Spinner defaultProps only accepts size, variant, colorScheme
  },
});
